module.exports = __webpack_public_path__ + "img/hot.png?4793fb406d26ddd6b79b871950df877b";